import { ConfigService } from '@maia/config';
import { HttpService } from '@maia/httpClient';
import { mergeDefaultParams } from '@maia/utils';
import { QueryObject, stringifyQuery } from 'ufo';

export class BaseService {
  constructor(
    protected httpService: HttpService,
    protected confgService: ConfigService,
  ) {}

  protected async getMany<T>(
    query: string | undefined,
    search: Record<string, unknown>,
    resourceName: string,
  ) {
    const searchParams = stringifyQuery(search as QueryObject);
    const defaultPaginationParams = {
      page: '1',
      limit: this.confgService.get('pageSize'),
    };

    const url = mergeDefaultParams(
      `${query}?${searchParams}`,
      defaultPaginationParams,
    );

    return await this.httpService.fetch<T[]>(url, `${resourceName}`);
  }

  protected async get<T>(query: string, resourceName: string): Promise<T> {
    const { response } = await this.httpService.fetch<T>(
      query,
      `${resourceName}`,
    );
    return response;
  }

  protected async post<TResponse, TPayload>(
    query: string,
    body: TPayload,
    resourceName: string,
  ) {
    const { response } = await this.httpService.post<TResponse, TPayload>(
      query,
      body,
      `${resourceName}`,
    );
    return response;
  }

  protected async put<TResponse, TPayload>(
    query: string,
    body: TPayload,
    resourceName: string,
  ) {
    const { response } = await this.httpService.put<TResponse, TPayload>(
      query,
      body,
      `${resourceName}`,
    );
    return response;
  }

  protected async delete<TResponse>(query: string, resourceName: string) {
    const { response } = await this.httpService.delete<TResponse>(
      query,
      `${resourceName}`,
    );
    return response;
  }
}
